// Registro dei "moduli" di import che condividono la stessa identica logica
// (upload file cliente -> mappa colonne su un tracciato fisso -> template
// salvati per cliente -> revisione -> export): Home/Mapping/Revisione sono
// gli stessi componenti per tutti, cambia solo tracciato e percorso base.
export const MODULI = {
  diba: { percorsoBase: "/distinta-base", etichettaSessione: "IMPORT DISTINTE BASI", etichettaNav: "DISTINTA BASE" },
  ddt: { percorsoBase: "/ddt", etichettaSessione: "IMPORT DDT", etichettaNav: "DDT" },
};

// "diba" resta il default: è il modulo storico, prima che esistesse questo
// concetto, quindi qualunque percorso non riconosciuto (es. "/", "/ordini")
// ricade su di esso solo per compatibilità dei link diretti alle vecchie
// pagine — le pagine dei moduli (Home/Mapping/Revisione) vengono montate
// SOLO sotto i percorsi effettivi di App.js, quindi in pratica questo ramo
// scatta solo se qualcuno modifica l'URL a mano.
export function moduloDaPercorso(pathname) {
  if (pathname.startsWith(MODULI.ddt.percorsoBase)) return "ddt";
  return "diba";
}
